import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-layout" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "login-layout__delimiter" }, null, -1)
const _hoisted_3 = { class: "login-layout__end" }
const _hoisted_4 = { class: "login-layout__footer" }
const _hoisted_5 = { class: "login-layout__action-bar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['login-layout__start', { 'login-layout__start_wide': _ctx.startWide }])
    }, [
      _renderSlot(_ctx.$slots, "start")
    ], 2),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "end")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "footer")
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "action-bar")
    ])
  ]))
}